import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const ExclamationComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__exclamation"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.57514 3.21672L1.51681 15C1.37128 15.2521 1.29428 15.5378 1.29346 15.8288C1.29265 16.1198 1.36805 16.406 1.51216 16.6588C1.65627 16.9116 1.86408 17.1223 2.1149 17.2699C2.36571 17.4175 2.65081 17.4968 2.94181 17.5H17.0585C17.3495 17.4968 17.6346 17.4175 17.8854 17.2699C18.1362 17.1223 18.344 16.9116 18.4881 16.6588C18.6322 16.406 18.7076 16.1198 18.7068 15.8288C18.706 15.5378 18.629 15.2521 18.4835 15L11.4251 3.21672C11.2766 2.9718 11.0674 2.76931 10.8178 2.62879C10.5682 2.48826 10.2866 2.41443 10.0001 2.41443C9.71369 2.41443 9.43208 2.48826 9.18248 2.62879C8.93287 2.76931 8.7237 2.9718 8.57514 3.21672Z"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 7.5V10.8333" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 14.1666H10.0083" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const Exclamation = withIcon(ExclamationComponent);
